<script setup lang="ts">
const props = defineProps({
  documentId: {
    type: String,
    required: true,
  },
});

const docStore = useSubmittedDocumentStore(props.documentId);
const { revision, submittedDocument, isDocumentInitialized } =
  storeToRefs(docStore);
const hasMediaObject = computed(() => {
  return (
    revision.value?.fileObject != undefined ||
    (revision.value?.fileObjects != undefined &&
      revision.value.fileObjects.length > 0)
  );
});
</script>

<template>
  <div>
    <div
      v-if="hasMediaObject != true"
      class="bg-surface p-12 border shadow rounded-tl rounded-tr w-full min-h-full focus:outline-none selection:bg-none overflow-hidden"
    >
      <div class="w-full h-full flex flex-col">
        <BaseSkeleton class="h-[18px] w-[130px] mb-4" />
        <BaseSkeleton class="h-[18px] w-[130px] mb-4" />
        <BaseSkeleton class="h-[18px] w-[200px] mx-auto mb-4" />
        <BaseSkeleton class="h-[18px] w-full mb-4" />
        <BaseSkeleton class="h-[18px] w-full mb-4" />
        <BaseSkeleton class="h-[18px] w-full mb-4" />
        <BaseSkeleton class="h-[18px] w-full mb-4" />
        <BaseSkeleton class="h-[18px] w-full mb-4" />
        <BaseSkeleton class="h-[18px] w-full mb-4" />
        <BaseSkeleton class="h-[18px] w-[20%] mb-4" />
        <BaseSkeleton class="h-[18px] w-full mb-4" />
        <BaseSkeleton class="h-[18px] w-full mb-4" />
        <BaseSkeleton class="h-[18px] w-full mb-4" />
        <BaseSkeleton class="h-[18px] w-full mb-4" />
        <BaseSkeleton class="h-[18px] w-full mb-4" />
        <BaseSkeleton class="h-[18px] w-full mb-4" />
        <BaseSkeleton class="h-[18px] w-[20%] mb-4" />
        <BaseSkeleton class="h-[18px] w-full mb-4" />
        <BaseSkeleton class="h-[18px] w-full mb-4" />
        <BaseSkeleton class="h-[18px] w-full mb-4" />
        <BaseSkeleton class="h-[18px] w-full mb-4" />
        <BaseSkeleton class="h-[18px] w-full mb-4" />
        <BaseSkeleton class="h-[18px] w-full mb-4" />
        <BaseSkeleton class="h-[18px] w-[20%] mb-4" />
      </div>
    </div>
    <div v-if="hasMediaObject == true"></div>
  </div>
</template>

<style scoped></style>
